import { apiClient, USE_MOCK } from "./apiClient";
import mockDb from "./mockDb";

export const AuthService = {
  loginAdmin: async (email, password) => {
    if (USE_MOCK) return mockDb.login('admin', email, password);
    const { data } = await apiClient.post("/auth/admin/login", { email, password });
    return data;
  },

  loginEmployee: async (email, password) => {
    if (USE_MOCK) return mockDb.login('employee', email, password);
    const { data } = await apiClient.post("/auth/employee/login", { email, password });
    return data;
  },

  logout: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userRole");
    // Optionally call backend logout
  }
};
